<template>
  <router-view v-if="ready" />
</template>

<script>
const cookies = require("js-cookie");

import api from "./services/api";
import config from "./config/index";
import { useMainStore } from "./stores/store";
import { useReviewStore } from "./stores/reviews";
import { withReturnParam } from "./util/returnPath";

export default {
  components: {},
  data: () => ({
    ready: false,
  }),
  beforeMount() {
    if (
      !location.pathname.startsWith("/inloggen") &&
      !location.pathname.startsWith("/link") &&
      !location.pathname.startsWith("/registratie-voltooien") &&
      !location.pathname.startsWith("/wachtwoord-wijzigen") &&
      !location.pathname.startsWith("/wachtwoord-vergeten")
    ) {
      // Terugkeerpad: preserve the Deeplink the user opened so login returns
      // them to it instead of the dashboard (docs/adr/0028).
      const loginUrl = withReturnParam(
        `${config.url.login}/inloggen`,
        location.pathname,
        location.search
      );

      if (cookies.get("fmw_refresh_token")) {
        api
          .get(`/v1/users/me/info`)
          .then((res) => {
            if (res.data.role == "admin") {
              useMainStore().$patch({
                user: res.data,
              });
              this.ready = true;
              // Background preload, so the Reviews page opens from the store.
              useReviewStore().preload().catch(() => {});
            } else {
              cookies.remove("fmw_access_token", {
                domain: config.cookiedomain,
                path: "/",
              });
              cookies.remove("fmw_refresh_token", {
                domain: config.cookiedomain,
                path: "/",
              });
              cookies.remove("user", {
                domain: config.cookiedomain,
                path: "/",
              });
              location.replace(loginUrl);
            }
          })
          .catch(() => {
            cookies.remove("fmw_access_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("fmw_refresh_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("user", {
              domain: config.cookiedomain,
              path: "/",
            });
            location.replace(loginUrl);
          });
      } else {
        location.replace(loginUrl);
      }
    } else {
      this.ready = true;
    }
  },
};
</script>
